import React from 'react';

import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { LoyaltyPointsButton } from 'components/loyalty-points-button';
import useAuth from 'hooks/auth/use-auth';
import { useGetLoginRoute } from 'hooks/navigation/use-get-login-route';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { useRoute } from 'hooks/navigation/use-route';
import { useAuthContext } from 'state/auth';
import { ModalAuthScreen } from 'state/auth/types';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

const MobileHeaderCta = () => {
  const { formatMessage } = useIntl();

  const enableSignUp = useFlag(LaunchDarklyFlag.ENABLE_SIGN_UP);
  const { isAuthenticated } = useAuthContext();
  const { setModalAuthState } = useAuth();
  const loginRoute = useGetLoginRoute();
  const { navigate } = useNavigation();
  const { pathname } = useRoute();

  const onPress = () => {
    if (routes.base === pathname) {
      setModalAuthState({
        screen: ModalAuthScreen.SIGN_IN,
      });
    } else {
      navigate(loginRoute);
    }
  };

  if (isAuthenticated) {
    return (
      <>
        <LoyaltyPointsButton />
      </>
    );
  }

  if (!enableSignUp) {
    return null;
  }

  return (
    <ActionButton
      variant={ActionButtonVariants.PRIMARY}
      size={ActionButtonSizes.SMALL}
      onPress={onPress}
      testID="mobile-nav-signup-link"
      alignSelf="center"
    >
      {formatMessage({ id: 'signInUp' })}
    </ActionButton>
  );
};

export default MobileHeaderCta;
